"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
* Enum class ResultCode.
* @enum {}
* @readonly
*/
class ResultCode {
  constructor() {
    /**
     * value: "SUCCESS"
     * @const
     */
    _defineProperty(this, "SUCCESS", "SUCCESS");
    /**
     * value: "FAILURE"
     * @const
     */
    _defineProperty(this, "FAILURE", "FAILURE");
    /**
     * value: "GENERIC_FAILURE"
     * @const
     */
    _defineProperty(this, "GENERIC_FAILURE", "GENERIC_FAILURE");
    /**
     * value: "BAD_REQUEST"
     * @const
     */
    _defineProperty(this, "BAD_REQUEST", "BAD_REQUEST");
    /**
     * value: "NOT_FOUND"
     * @const
     */
    _defineProperty(this, "NOT_FOUND", "NOT_FOUND");
    /**
     * value: "UNAUTHORIZED"
     * @const
     */
    _defineProperty(this, "UNAUTHORIZED", "UNAUTHORIZED");
    /**
     * value: "NOT_ALLOWED"
     * @const
     */
    _defineProperty(this, "NOT_ALLOWED", "NOT_ALLOWED");
    /**
     * value: "INCORRECT_EMAIL_OR_PASSWORD"
     * @const
     */
    _defineProperty(this, "INCORRECT_EMAIL_OR_PASSWORD", "INCORRECT_EMAIL_OR_PASSWORD");
    /**
     * value: "CREATED"
     * @const
     */
    _defineProperty(this, "CREATED", "CREATED");
    /**
     * value: "TWO_STEP_REQUIRED"
     * @const
     */
    _defineProperty(this, "TWO_STEP_REQUIRED", "TWO_STEP_REQUIRED");
    /**
     * value: "MULTI_USER"
     * @const
     */
    _defineProperty(this, "MULTI_USER", "MULTI_USER");
    /**
     * value: "SUBSCRIPTION_EXPIRED"
     * @const
     */
    _defineProperty(this, "SUBSCRIPTION_EXPIRED", "SUBSCRIPTION_EXPIRED");
  }
  /**
  * Returns a <code>ResultCode</code> enum value from a Javascript object name.
  * @param {Object} data The plain JavaScript object containing the name of the enum value.
  * @return {module:model/ResultCode} The enum <code>ResultCode</code> value.
  */
  static constructFromObject(object) {
    return object;
  }
}
exports.default = ResultCode;